import React, { Component } from 'react';
import './Piechart.css';


//customize piechart author abdul

class Piechart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "piedataLoaded": false, data: [], path: '',
            x: 0,
            y: 0
        };
    }


    componentDidMount() {
        console.log("piechart loaded")
        // setInterval(function () {
        var dataSize = 3, data = [];

        for (; dataSize--;) {
            data.push(this.getRandomInt(1, 20));
        }

        this.setState({ data: [] });

        // }.bind(this), 2000);
    }

    getAnglePoint(startAngle, endAngle, radius, x, y) {
        var x1, y1, x2, y2;

        x1 = x + radius * Math.cos(Math.PI * startAngle / 180);
        y1 = y + radius * Math.sin(Math.PI * startAngle / 180);
        x2 = x + radius * Math.cos(Math.PI * endAngle / 180);
        y2 = y + radius * Math.sin(Math.PI * endAngle / 180);

        return { x1, y1, x2, y2 };
    }

    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    getInitialState() {
        return {
            data: [5, 12, 8]
        }
    }

    render() {
        var colors = this.props.colors;
        var data = this.props.data;
        var txtval = this.props.txtval;
        return (
            <div>

                <Pie
                    data={data}
                    radius={60}
                    hole={55}
                    colors={colors}
                    txtval={txtval}
                />
            </div>
        );
    }
}

// labels={true}
// percent={true}

// strokeWidth={1}
// stroke={'#fff'}



export class Pie extends Piechart {
    constructor(props) {
        super(props);
    }

    render() {
        var colors = this.props.colors,
            colorsLength = colors.length,
            labels = this.props.labels,
            hole = this.props.hole,
            radius = this.props.radius,
            diameter = radius * 2,
            self = this,
            sum, startAngle, d = null;

        sum = this.props.data.reduce(function (carry, current) { return carry + current }, 0);
        //console.log(sum);
        startAngle = -90;


        return (

            <div>
                <svg id={"Piechart"} width={diameter} height={diameter} viewBox={'0 0 ' + diameter + ' ' + diameter} xmlns="http://www.w3.org/2000/svg" version="1.1">

                    {this.props.data.map(function (slice, sliceIndex) {
                        var angle, nextAngle, percent;

                        nextAngle = startAngle;
                        angle = (slice / sum) * 360;
                        percent = (slice / sum) * 100;
                        startAngle += angle;

                        return <Slice
                            key={sliceIndex}
                            value={slice}
                            percent={self.props.percent}
                            percentValue={Math.floor(percent)}
                            startAngle={nextAngle}
                            angle={angle}
                            radius={radius}
                            hole={radius - hole}
                            trueHole={hole}
                            showLabel={labels}
                            fill={colors[sliceIndex % colorsLength]}
                            stroke={self.props.stroke}
                            strokeWidth={self.props.strokeWidth} 
                        />
                    })}
                    <text x={radius} y={radius + 10} className="tval" >
                    
                        {this.props.txtval.map(function (slicetxt, slicetxtIndex) {
                            let boxClass = ["tvl"];
                            boxClass.push(slicetxtIndex)
                            return (
                                <tspan className={boxClass.join('')} key={slicetxtIndex}>{slicetxt}</tspan>
                            )
                        }
                        )}
    
                    </text>

                </svg>
            </div>

        );
    }
}


export class Slice extends Piechart {
    constructor(props) {
        super(props);
        this.state = {
            path: '',
            x: 0,
            y: 0
        }
        this.animate = this.animate.bind(this);
        this.draw = this.draw.bind(this);
    }
    getInitialState() {
        return {
            path: '',
            x: 0,
            y: 0
        };
    }
    componentWillReceiveProps() {
        console.log("slice again")
       // this.setState({ path: ''});
        //this.animate();
    }

    componentDidMount() {
        console.log("slice loaded")
       this.animate();
    }

    componentWillUnmount() {
       // console.log("removed")
       // this.ifMounted.unmount();
    }

    animate() {
            this.draw(0);
    }


    draw(s) {
       
        // if (!this.isMounted()) {
        //     return;
        // }

        var p = this.props, path = [], a, b, c, self = this, step;

        step = p.angle / (37.5 / 2);
       
        if (s + step > p.angle) {
            s = p.angle-0.01;
        }
        //console.log("draw  "+s +" "+ step+" "+p.angle)
        // Get angle points
        a = this.getAnglePoint(p.startAngle, p.startAngle + s, p.radius, p.radius, p.radius);
        b = this.getAnglePoint(p.startAngle, p.startAngle + s, p.radius - p.hole, p.radius, p.radius);

        path.push('M' + a.x1 + ',' + a.y1);
        path.push('A' + p.radius + ',' + p.radius + ' 0 ' + (s > 180 ? 1 : 0) + ',1 ' + a.x2 + ',' + a.y2);
        path.push('L' + b.x2 + ',' + b.y2);
        path.push('A' + (p.radius - p.hole) + ',' + (p.radius - p.hole) + ' 0 ' + (s > 180 ? 1 : 0) + ',0 ' + b.x1 + ',' + b.y1);

        // Close
        path.push('Z');

        this.setState({ path: path.join(' ') });

        if (s < p.angle) {
            setTimeout(function () { self.draw(s + step) }, 16);
        } else if (p.showLabel) {
            c = this.getAnglePoint(p.startAngle, p.startAngle + (p.angle / 2), (p.radius / 2 + p.trueHole / 2), p.radius, p.radius);
            console.log(c);
            this.setState({
                x: c.x2,
                y: c.y2
            });
        }
    }
    render() {


        return (
            <g overflow="hidden">
                <path
                    d={this.state.path}
                    fill={this.props.fill}
                    stroke={this.props.stroke}
                    strokeWidth={this.props.strokeWidth ? this.props.strokeWidth : 3}
                />
                {this.props.showLabel && this.props.percentValue > 5 ?
                    <text x={this.state.x} y={this.state.y} fill="#fff" textAnchor="middle">
                        {this.props.percent ? this.props.percentValue + '%' : this.props.value}
                    </text>
                    : null}
            </g>

        );
    }
}
export default Piechart;


// WEBPACK FOOTER //
// ./src/views/scorecard/Piechart.js